import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteFeature, getFeatures, editFeature, changeOrder } from '../../store/actions/feature/feature.action';
import PageLoader from '../../components/Common/PageLoader';
import FeaturesList from '../../components/Features/Features';

const FeaturesContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const isCreating = useSelector((state) => state.feature.isCreating);
  const features = useSelector((state) => state.feature.list);
  const isFetching = useSelector((state) => state.feature.isFetching);
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      const featureCategory = categories.find((category) => category.link === 'features');
      if (featureCategory) {
        setMode(featureCategory.mode);
        setAccessDenied(false);
      } else {
        throw new Error('Feature category not found');
      }
    } catch (err) {
      setAccessDenied(true);
    }
  }, [categories]);

  // Action handlers
  const handleDeleteFeature = useCallback((feature) => {
    dispatch(deleteFeature(feature));
  }, [dispatch]);

  const handleGetFeatures = useCallback(() => {
    dispatch(getFeatures());
  }, [dispatch]);

  const handleEditFeature = useCallback((feature) => {
    dispatch(editFeature(feature));
  }, [dispatch]);

  const handleChangeOrder = useCallback((orderData) => {
    dispatch(changeOrder(orderData));
  }, [dispatch]);

  // Initialize on mount
  useEffect(() => {
    handleGetFeatures();
    setAccess();
  }, [handleGetFeatures, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return <div>This category is not accessible to the logged in user.</div>;
  }

  // Prepare feature info object
  const featureInfo = {
    deleteFeature: handleDeleteFeature,
    features
  };

  return (
    <section className="features-list">
      <FeaturesList
        mode={mode}
        featureInfo={featureInfo}
        editFeature={handleEditFeature}
        changeOrder={handleChangeOrder}
        getFeatures={handleGetFeatures}
      />
    </section>
  );
};

export default FeaturesContainer;
